import { render, staticRenderFns } from "./WxOrderDetail.vue?vue&type=template&id=0e7b5ceb&scoped=true"
import script from "./WxOrderDetail.vue?vue&type=script&lang=js"
export * from "./WxOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./WxOrderDetail.vue?vue&type=style&index=0&id=0e7b5ceb&prod&scoped=true&lang=css"
import style1 from "./WxOrderDetail.vue?vue&type=style&index=1&id=0e7b5ceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b5ceb",
  null
  
)

export default component.exports